import { z } from 'zod'

export const OnboardingSchema = z.object({
    token: z.string().min(1),
    firstName: z.string().trim().min(1, { message: 'First name is required' }).max(100),
    lastName: z.string().trim().min(1, { message: 'Last name is required' }).max(100),
    dateOfBirth: z.coerce.date().optional(),
    acceptedTerms: z.literal(true, { message: 'You must accept the terms' }),
    acceptedPrivacy: z.literal(true, { message: 'You must accept the privacy policy' })
})

export type OnboardingInput = z.infer<typeof OnboardingSchema>

export const AcceptInvitationFormSchema = z.object({
    firstName: z.string().trim().min(1, { message: 'First name is required' }).max(100),
    lastName: z.string().trim().min(1, { message: 'Last name is required' }).max(100),
    dateOfBirth: z.string().optional(),
    image: z.string().optional(),
    acceptedTerms: z.boolean().refine((v) => v === true, { message: 'You must accept the terms' }),
    acceptedPrivacy: z.boolean().refine((v) => v === true, { message: 'You must accept the privacy policy' })
})

export type AcceptInvitationFormValues = z.infer<typeof AcceptInvitationFormSchema>

export const AcceptInvitationPatientFormSchema = AcceptInvitationFormSchema.extend({
    dateOfBirth: z.string().trim().min(1, { message: 'Date of birth is required' })
})

export type AcceptInvitationPatientFormValues = z.infer<typeof AcceptInvitationPatientFormSchema>

export const RegisterMedicalSchema = z.object({
    email: z.string().email({ message: 'Invalid email address' }),
    firstName: z.string().min(1, { message: 'First name is required' }).max(100),
    lastName: z.string().min(1, { message: 'Last name is required' }).max(100),
    image: z.string().optional(),
    medicalLicenseNumber: z.string().min(1, { message: 'Medical license number is required' }),
    confirmMedicalRole: z.boolean().refine((v) => v === true, { message: 'You must confirm your role' }),
    acceptedTerms: z.boolean().refine((v) => v === true, { message: 'You must accept the terms' }),
    acceptedPrivacy: z.boolean().refine((v) => v === true, { message: 'You must accept the privacy policy' })
})

export type RegisterMedicalFormValues = z.infer<typeof RegisterMedicalSchema>
